import React from 'react'
import SEO from '../components/seo'
import Homepage from '../components/Homepage'

const IndexPage = () => (
  <>
    <SEO
      title="home"
      keywords={[`Ellington Hammond`, `photographer`, `film director`, `creative`]}
    />

    <Homepage />
  </>
)

export default IndexPage
